import React, { useEffect, useState } from 'react';
import CustomSelect from '../components/CustomSelect';
import ListeNotificationPush from './ListeNotificationPush';
import ComponentInput from '../components/componentInput';
import FiltreDate from '../components/FiltreDate';
import CustomCheckBox from '../components/CustomCheckBox';

const EUROPEAN_COUNTRIES = [
  "Chypre", "Croatie", "Danemark", 
  "Espagne", "Estonie", "Finlande", "France", "Grèce", "Hongrie", "Irlande", 
  "Italie", "Lettonie", "Lituanie", "Luxembourg", "Malte", "Pays-Bas", "Pologne", 
  "Portugal", "République Tchèque", "Roumanie", "Slovaquie", "Slovénie", "Suède"
];

const DESTINATION_COUNTRIES = [
{ value: 'TND',label:'Tunisie'},
{value: 'XOF', label:'Sénégal',},
{value: 'MAD', label:'Maroc'},
{value: 'PKR', label:'Pakistan'},
{value: 'BDT', label:'Bangladesh'},
{value: 'TRY', label:'Turquie'}


]
const listeCibleKYC=[
  {value:'all', label:'Tous les utilisateurs'},
  {value:'Inscription', label:'Inscription'},
  {value:'kyc', label:'kyc'},
  {value:'1er activité', label:'1er activité'},
  
]
const ListcontactOptions = [
  { value: 'all', label: 'Tous' },
  { value: 'called', label: 'Appelé' },
  { value: 'notCalled', label: 'Non appelé' },
];

const transferActivityOptions=[
  {value:"all", label:'Tous'},
  {value:'Tcash', label:"Transfert d'argent avec retrait en Cash"},
  {value:'Tbancaire', label:'Transfert d’argent de compte à compte'},
  {value:'Twallet', label:"Transfert vers wallet"},
  {value:'Rprepayee', label:"Recharge de carte prépayée"},
  {value:'Rmobile', label:"Envoi Recharge Mobile"},


  // {value:'lastTransfer', label:"Dernier transfert"}
]

const listeManipulation=[
  '0 Bonus',
'Activation manuelle',
'Ajout Bonus',
'Ajout Bonus conformité',
'Ajout taux speciale',
'Appel KYC',
'Bonus de Parrainage',
'Bonus parrainage Maroc',
]

const NotificationManager = () => {
  const [message, setMessage] = useState('');
   const [loading, setLoading] = useState(false);
  const [startDateTransfert, setStartDateTransfert] = useState('')
  const [endDateTransfert, setEndDateTransfert] = useState('')

  const [startDateManipulation, setStartDateManipulation] = useState()
  const [endDateManipulation, setEndDateManipulation] = useState()

  const [startDateAction, setStartDateAction] = useState('')
  const [endDateAction, setEndDateAction] = useState('')
  
  const [filters, setFilters] = useState({
    kycStatus: 'all',  
    country: 'all',       
    hasTransferred: 'all'  ,
    Destcountry:'all',
    contactOptions:'all',
    manipulation:[]
  });
  

 
  // console.log('filters', filters)
  console.log('enn', startDateTransfert, endDateTransfert, filters)

  const handleFilterChange = (val, id) => {
    setFilters(prev => ({ ...prev, [id]: val }));
  };

 
  const handleMessage=(e)=>{
    console.log('message', e.target.value)
    setMessage(e.target.value)
  }

  const handleSend = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      message: message,
      target: filters
    };

    console.log("Données envoyées au backend :", payload);

    setTimeout(() => {
      setLoading(false);
      setMessage(''); 
    }, 800);
  };

    useEffect(()=>{
      if(filters.hasTransferred !=='firstTransfer' && filters.hasTransferred !=='lastTransfer')
      {setEndDateTransfert(null)
      setStartDateTransfert(null)}
    },[filters.hasTransferred])

  return (
    <div>
       <div className=" mx-auto p-6 bg-white shadow-md rounded-lg mt-10 border border-gray-100">
      {/* <h2 className="text-xl font-bold mb-6 text-gray-800 border-b pb-2">🚀 Envoyer une Notification</h2> */}
            <h2 className="text-[20px] font-medium w-full text-left border-b pb-4">Envoyer une Notification</h2>


      <form onSubmit={handleSend} className="space-y-8  ">
        

          
          <div className='grid grid-cols-1 md:grid-cols-2  gap-4 pt-4'>
              <CustomSelect id="country" label='Pays résidence'  options={EUROPEAN_COUNTRIES} value={filters.country} placeholder="Toute l'Europe" onChange={handleFilterChange} styleSlect='top-full' />
              <CustomSelect id="Destcountry" label='Pays de destination'  options={DESTINATION_COUNTRIES} value={filters.Destcountry} placeholder="Toute les pays" onChange={handleFilterChange} styleSlect='top-full' />
              

              <div className='w-full flex gap-2 '>
                <div className='w-full'>
                <CustomSelect id="kycStatus" label='Action client'  options={listeCibleKYC} value={filters.kycStatus} placeholder='tous les utilisateurs' onChange={handleFilterChange} styleSlect='top-full' />
                </div>
                 <div className='flex items-end  w-[300px]'>
                <FiltreDate setStartDateProps={setStartDateAction}  setEndDateProps={setEndDateAction}/>
                </div>
              </div>
                <CustomSelect id="hasTransferred" label='Activité'  options={transferActivityOptions} value={filters.hasTransferred} onChange={handleFilterChange} styleSlect='top-full'  />
              
              {/* <div className='w-full flex gap-2 '>
                <div className='w-full'>
                <CustomSelect id="hasTransferred" label='Activité'  options={transferActivityOptions} value={filters.hasTransferred} onChange={handleFilterChange} styleSlect='top-full'  />
                </div>
                {(filters.hasTransferred==='firstTransfer' || filters.hasTransferred==='lastTransfer' ) &&
                <div className='flex items-end  w-[300px]'>
                <FiltreDate setStartDateProps={setStartDateTransfert}  setEndDateProps={setEndDateTransfert}/>
                </div>
                }
              </div> */}

              {/* <div className='w-full flex gap-2 '>
              <CustomCheckBox id='manipulation' label='Raison de derniere manipulation' option={listeManipulation} listSlect={filters.manipulation} 
                setListeSelect={(newListe)=>setFilters(prev => ({ ...prev, 'manipulation': newListe }))} 
                placeholder='slectionnez les raison de manipulation'  
                listSlected={filters.manipulation}
              />              
                <div className='flex items-end  w-[300px]'>
                <FiltreDate setStartDateProps={setStartDateManipulation}  setEndDateProps={setEndDateManipulation}/>
                </div>
              </div> */}

          </div>
           
          <div className='flex'>
          {ListcontactOptions.map((item,index)=>(
            <label key={index} className='px-2  cursor-pointer' >
              <input
              className='mr-1'
              type='radio'
              val={item.label}
              checked={filters.contactOptions=== item.value}
              onChange={(e)=>{
                handleFilterChange(item.value, 'contactOptions')
              }}
              />
              {item.label} 

            </label>
          ))}
          </div>
            <ComponentInput label='Message de la notification' required typeInput='textarea' placeholder='Tapez votre message ici...'  name='description' valueInput={message}  onChange={handleMessage} />
            <p className="text-xs text-gray-400 mt-1 text-right">
              {message.length} caractères
            </p>
           
          {/* </div> */}
      

      

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white font-bold py-3 rounded hover:bg-blue-700 disabled:bg-gray-400 transition-colors"
        >
          {loading ? "Envoi en cours..." : "Envoyer maintenant"}
        </button>

      </form>
    </div>
        <div className=" mx-auto w-auto p-6 bg-white shadow-md rounded-lg mt-10 border border-gray-100">
          <ListeNotificationPush/>
        </div>
    </div>
   
  );
};

export default NotificationManager;